import { Component, OnInit } from "@angular/core";
import { GlobalService } from "../global.service";
import { LoadingScreenService } from "../services/loading-screen/loading-screen.service";
import { FlashController } from './flash-payment-core/services/flash-controller.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
  selector: "app-flash-payment",
  templateUrl: "./flash-payment.component.html",
  styleUrls: ["./flash-payment.component.sass"],
})
export class FlashPaymentComponent implements OnInit {
  postpago;
  prepago;
  telefoniaFijo;
  totalAccountList;
  currentList;
  selectBan;
  tabActive = "Factura y Pago";
  token = sessionStorage.getItem("token");
  banlist;
  lastPaymentAmountField;
  cycleDateField;
  billBalanceField;
  cycleEndDateField;
  cycleStartDateField;
  billDueDateField;
  pastDueAmountField;
  initialize: Subscription;
  canUpdateAmount = false;
  editOperationAmount = '';
  loadObserver: Subscription;

  constructor(
    public global: GlobalService,
    private loadingScreenService: LoadingScreenService,
    public flashPaymentService: FlashController,
    public router: Router,
    private location: Location,
  ) {
  }

  ngOnInit() {
    this.checkIfHasData();
    this.evaluateDataFromRedirect();
    console.log(navigator.userAgent.toLowerCase());
  }

  checkIfHasData() {
    if (!sessionStorage.getItem('flash-data')) {
      this.router.navigate(['/home'])
    } else {
      this.flashPaymentService.controller = JSON.parse(sessionStorage.getItem('flash-data'));
      this.fromInvoiceView();
      this.flashLogin();
      this.flashPaymentService.getTokenCards();
      this.flashPaymentService.getLocalData();
    }
  }

  evaluateDataFromRedirect() {
    const sessionToken = this.router.parseUrl(this.router.url).queryParams['st'];
    const paymenToken = this.router.parseUrl(this.router.url).queryParams['pt'];
    const typeResult = this.router.parseUrl(this.router.url).queryParams['type'];
    const athData: string = this.router.parseUrl(this.router.url).queryParams['apprCode'];
    if (sessionToken || paymenToken || typeResult || athData) {
      if (athData) {
        const athList = athData.split(',');
        const authorizationNumber = athList[0];
        const confirmationNumber = athList[1];
        this.flashPaymentService.processRedirectInfo(sessionToken, paymenToken, typeResult, authorizationNumber, confirmationNumber);
      } else {
        this.flashPaymentService.processRedirectInfo(sessionToken, paymenToken, typeResult);
      }
    }
    this.location.go('/flash-payment');
  }

  initializeData() {
    // this.loadingScreenService.startLoading();
    console.log('disparando cambio de vista')
    this.global.refreshDataTo(this.token);
  }

  fromInvoiceView() {
    this.global.validateSession();
    if (this.global.sessionReview() == true) {
      this.banlist = JSON.parse(atob(sessionStorage.getItem("AccountList")));
      this.selectBan = atob(sessionStorage.getItem("selectBan"));
      this.getAccountInfoFormStorage();
      this.loadingScreenService.stopLoading();
      this.initialize = this.global.initialize.subscribe((value: number) => {
        this.initializeData();
      });
      this.loadObserver = this.global.loadObserver.subscribe(
        (value: number) => {
          this.dataLoading(value);
        }
      );
    }
  }

  dataLoading(sw) {
    this.loadingScreenService.stopLoading();
    this.getAccountInfoFormStorage();
  }

  getAccountInfoFormStorage() {
    this.lastPaymentAmountField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.lastPaymentAmountField;
    this.cycleDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDateField;
    this.billBalanceField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
    this.cycleEndDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleEndDateField;
    this.cycleStartDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleStartDateField;
    this.billDueDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billDueDateField;
    this.pastDueAmountField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.pastDueAmountField;
  }

  flashLogin() {
    this.flashPaymentService.paymentLogin('1234');
  }

  keepAlive() {
    this.flashPaymentService.paymentKeepAlive();
  }

  flashLogout() {
    this.flashPaymentService.paymentLogout();
  }

  close() {
    this.flashPaymentService.controller.openWeb = false;
  }

  changeAmount(event) {
    if (event.value.toString().substring((event.value.length - 2), (event.value.length)) === 'CR') {
      return
    } else {
      if (Number(event.value) >= 5 && Number(event.value) <= 2000) {
        this.flashPaymentService.controller.operationAmount = event.value;
        this.editOperationAmount = event.value;
      } else {
        this.global.notif('La cantidad a pagar debe ser mayor a $5.00 o menor de $2000.00');
        return;
      }
    }
  }

  activateChange(event) {
    console.log(event)
    if (event.edit) {
      if (event.value) {
        if (Number(event.value) >= 5 && Number(event.value) <= 2000) {
          this.flashPaymentService.controller.operationAmount = event.value;
          this.editOperationAmount = event.value;
        } else {
          this.global.notif('El monto debe ser mayor o igual a 5$ y menor o igual a $2000.00');
          return;
        }
      }
    }
    if (this.flashPaymentService.controller.transactionType === 'INVOICE PAYMENTS') {
      this.canUpdateAmount = !this.canUpdateAmount;
    }

  }
}
